<template>
    <div class="cards-bg min-vh-100 d-flex align-items-center justify-content-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <div class="card my-5">
                        <strong class="card-header">
                            Join Room #{{ $route.params.code }}
                        </strong>
                        <b-form @submit.prevent="onSubmit">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col flex-grow-0">
                                        <avatar :name="player.name"
                                                :colour="player.colour"></avatar>
                                    </div>
                                    <div class="col flex-grow-1">
                                        <b-form-group label="Player Name"
                                                      label-for="name"
                                                      label-sr-only>
                                            <b-form-input size="lg"
                                                          id="name"
                                                          maxlength="250"
                                                          v-model="player.name"
                                                          type="text"
                                                          required
                                                          placeholder="Player name"></b-form-input>
                                        </b-form-group>

                                        <b-form-group label="Colour"
                                                      label-for="colour"
                                                      label-sr-only
                                                      class="mb-0">
                                            <div class="colour-picker d-block">
                                                <div class="colour-radio"
                                                     v-for="colour in colours"
                                                     :key="colour.hex">
                                                    <input type="radio"
                                                           :id="colour.name"
                                                           name="colour"
                                                           :value="colour.hex"
                                                           v-model="player.colour" />
                                                    <label :style="{
                                                        color: colour.hex,
                                                    }"
                                                           :for="colour.name">{{
                                                               colour.name
                                                           }}</label>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer text-center">
                                <b-button size="lg"
                                          type="submit"
                                          variant="primary"
                                          class="font-weight-bold px-5">Join</b-button>
                            </div>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

export default {
    name: 'RoomShowSetup',
    components: {
        Avatar,
    },
    data() {
        return {
            colours: require('@/assets/colours.json'),
        };
    },
    computed: {
        player() {
            return this.$store.state.user;
        },
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('SET_USER', this.player).then(() => {
                this.$router.push({
                    name: 'RoomShow',
                });
            });
        },
    },
};
</script>
